import { Link, Tooltip } from "@material-ui/core";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { useGetLinkedTicketsByWorkOrderQuery } from "features/IssuesTracker/issuesTrackerSlice";
import { useTicketDialog } from "features/mechanicalWork/useTicketDialog";
import { workOrderLinkedTicketsStyles } from "./WorkOrderLinkedTicketsStyles";

const WorkOrderLinkedTickets = ({ workOrderId, onOpenTicket }) => {
    const classes = workOrderLinkedTicketsStyles();
    const { openTicket, prefetch, ticketDialog } = useTicketDialog(onOpenTicket);

    const { data: linkedTickets = [], isLoading } = useGetLinkedTicketsByWorkOrderQuery(workOrderId, { skip: !workOrderId });

    if (isLoading) {
        return null;
    }

    return (
        <Authorize profile={permissionProfiles.ISSUETRACKER.ISSUE_TRACKER_VIEW}>
            <div className={classes.linkedTicketsRow}>
                {linkedTickets.length === 0 ?
                    <span className={classes.emptyState}>No linked ticket</span>
                    :
                    <>
                        <span className={classes.label}>{linkedTickets.length > 1 ? 'Linked Tickets:' : 'Linked Ticket:'}</span>
                        {linkedTickets.map(ticket =>
                            <Tooltip key={ticket.id} title={ticket.title ? `Open ticket: ${ticket.title}` : 'Open ticket'}>
                                <Link
                                    component="button"
                                    type="button"
                                    underline="none"
                                    className={classes.pill}
                                    aria-label={`Open ticket ${ticket.id}`}
                                    onMouseEnter={() => prefetch(ticket.id)}
                                    onFocus={() => prefetch(ticket.id)}
                                    onClick={() => openTicket(ticket.id)}
                                >
                                    <ConfirmationNumberOutlinedIcon className={classes.pillIcon} />
                                    <span>#{ticket.id}</span>
                                    <OpenInNewIcon className={classes.pillIcon} />
                                </Link>
                            </Tooltip>
                        )}
                    </>
                }
            </div>

            {ticketDialog}
        </Authorize>
    );
};

export default WorkOrderLinkedTickets;
